/**
 * File-name-safe cache key for synthesized sentence audio: 64-bit FNV-1a over the model file, the
 * voice, speed and phoneme string. Phonemes (not the sentence text) are hashed, so a front-end fix
 * that changes how a sentence is read, or a gap between words, also gets new audio; so does a new
 * model file.
 */
export function sentenceAudioCacheKey({
  model,
  phonemes,
  speed,
  voiceId,
}: {
  model: string;
  phonemes: string;
  speed: number;
  voiceId: string;
}): string {
  let hash = 0xcb_f2_9c_e4_84_22_23_25n;
  const prime = 0x1_00_00_00_01_b3n;
  for (const char of `${model}|${voiceId}|${speed}|${phonemes}`) {
    hash ^= BigInt(char.codePointAt(0) ?? 0);
    hash = BigInt.asUintN(64, hash * prime);
  }
  return `${voiceId}-${hash.toString(16).padStart(16, "0")}`;
}
